export enum DocumentStage {
  ASSESSMENT = "Required to start assessment",
  APPROVAL = "Required for formal approval",
  SETTLEMENT = "Required for settlement",
}

export enum VerificationStatus {
  UNVERIFIED = "Unverified",
  VERIFIED = "Verified",
  EXEMPTED = "Exempted",
  IN_REVIEW = "In review",
}
